import { useFetchError } from 'components/useFetchError/useFetchError'
import { SchemaModel, schemaModel } from '@schematicos/types'
import { useEffect, useRef, useState } from 'react'
import { supabaseClient } from 'lib/supabaseClient/supabaseClient'

type UseGetSchemaArgs =
  | {
      schemaId: string
    }
  | {
      skip: true
    }

export const useGetSchema = (args: UseGetSchemaArgs) => {
  const { handleFetchError } = useFetchError()
  const [schema, setSchema] = useState<SchemaModel>()
  const loadingRef = useRef(false)
  const schemaId = 'schemaId' in args ? args.schemaId : undefined

  useEffect(() => {
    if (loadingRef.current) {
      return
    }

    if ('skip' in args) {
      return
    }

    loadingRef.current = true

    void supabaseClient.functions
      .invoke(`schemas/${schemaId}`, { method: 'GET' })
      .then(({ data, error }) => {
        if (error) {
          throw error
        }

        const parsed = schemaModel.parse(data)

        setSchema(parsed)
      })
      .catch(handleFetchError('Failed to retrieve schema'))
      .finally(() => (loadingRef.current = false))

    return () => {
      loadingRef.current = false
      setSchema(undefined)
    }
  }, [schemaId])

  return {
    data: schema,
    loading: loadingRef.current
  }
}
